<template>
    <div class="page_container">
        <div class="page_header">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/personal' }">个人信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card class="page_card" v-loading="loading">

           <div class="personal_box">

             <template v-if="isEdit">
               <el-form :model="personalForm" :rules="personalFormRules" label-position="left" label-width="70px" ref="personalForm" size="small">
                 <ul>
                   <li>
                     <div class="flex_js_wrap">
                       <div class="title">基础信息</div>
                       <div class="ta-r">
                         <el-button v-if="isEdit" size="small" @click="handleClickCancel">取消</el-button>
                         <el-button v-if="isEdit" size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">保存</el-button>
                         <el-button v-if="!isEdit" size="small" type="primary"  @click="handleClickEdit">编辑</el-button>
                       </div>
                     </div>


                     <el-form-item label="头像：" prop="avatar"  class="align-items-center">
                       <div class="head_img">
                         <div class="hover_box">修改头像</div>
                         <el-upload action="" :show-file-list="false" :auto-upload="false" :on-change="handleClickUploadAvatar"></el-upload>
                         <img :src="personalForm.avatar ? personalForm.avatar :'https://download.hecoos.com/enlightv/2024-33/HZHxfRWpzAKjx5Crb3AM.jpg'" alt="">
                       </div>

                     </el-form-item>
                     <el-form-item label="姓名：" prop="name">
                       <el-input type="text" v-model="personalForm.name" placeholder="请输入姓名"></el-input>
                     </el-form-item>
                     <el-form-item label="手机号：" prop="phone" v-if="personalForm.phone">
                       <el-input type="text" v-model="personalForm.phone" disabled placeholder="请输入手机号"></el-input>
                     </el-form-item>
                     <el-form-item label="邮箱：" prop="email">
                       <el-input type="text" v-model="personalForm.email" disabled placeholder="请输入邮箱"></el-input>
                     </el-form-item>
                     <!--                   <el-form-item label="" prop="gender">-->
                     <!--                     <el-radio-group v-model="personalForm.gender">-->
                     <!--                       <el-radio :label="1">男</el-radio>-->
                     <!--                       <el-radio :label="2">女</el-radio>-->
                     <!--                       <el-radio :label="3">保密</el-radio>-->
                     <!--                     </el-radio-group>-->
                     <!--                   </el-form-item>-->
                     <!--                   <el-form-item label="年龄" prop="age">-->
                     <!--                     <el-input-number v-model="personalForm.age" placeholder="请输入年龄" :controls="false"></el-input-number>-->
                     <!--                   </el-form-item>-->

                   </li>

                   <!--                 <li>-->
                   <!--                   <div class="title">其他个人信息</div>-->

                   <!--                   <el-form-item label="个人地址" prop="attr">-->
                   <!--                     <el-input type="text" v-model="personalForm.attr" placeholder="请输入个人地址"></el-input>-->
                   <!--                   </el-form-item>-->
                   <!--                   <el-form-item label="职业" prop="profession">-->
                   <!--                     <el-input type="text" v-model="personalForm.profession" placeholder="请输入职业"></el-input>-->
                   <!--                   </el-form-item>-->

                   <!--                   <el-form-item label="教育背景" prop="age">-->
                   <!--                     <el-input-number v-model="personalForm.age" placeholder="请输入教育背景" :controls="false"></el-input-number>-->
                   <!--                   </el-form-item>-->

                   <!--                 </li>-->

                   <li>
                     <div class="title">账号安全</div>

                     <el-form-item label="" prop="" label-width="0">
                       <el-button type="primary" @click="handleClickChangePassword">修改密码</el-button>
                       <el-button type="primary" @click="handleClickChangeAccount">换绑账号</el-button>
                     </el-form-item>

                   </li>
                 </ul>
               </el-form>
             </template>
             <template v-else>
               <el-form  label-position="left"  size="small">
                 <ul>
                   <li>
                     <div class="flex_js_wrap">
                       <div class="title">基础信息</div>
                       <div class="ta-r">
                         <el-button v-if="isEdit" size="small" @click="handleClickCancel">取消</el-button>
                         <el-button v-if="isEdit" size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">保存</el-button>
                         <el-button v-if="!isEdit" size="small" type="primary"  @click="handleClickEdit">编辑</el-button>
                       </div>
                     </div>
                     <el-form-item label="头像：" prop="avatar"  class="align-items-center">
                       <div class="head_img">
                         <img :src="personalDetail.avatar ? personalDetail.avatar :'https://download.hecoos.com/enlightv/2024-33/HZHxfRWpzAKjx5Crb3AM.jpg'" alt="">
                       </div>

                     </el-form-item>
                     <el-form-item label="姓名：" prop="name">
                       <div class="" v-text="personalDetail.name"></div>
                     </el-form-item>
                     <el-form-item label="手机号：" prop="phone" v-if="personalDetail.phone">
                       <div class="" v-text="personalDetail.phone"></div>
                     </el-form-item>
                     <el-form-item label="邮箱：" prop="email">
                       <div class="" v-text="personalDetail.email"></div>
                     </el-form-item>
                     <!--                   <el-form-item label="" prop="gender">-->
                     <!--                     <el-radio-group v-model="personalForm.gender">-->
                     <!--                       <el-radio :label="1">男</el-radio>-->
                     <!--                       <el-radio :label="2">女</el-radio>-->
                     <!--                       <el-radio :label="3">保密</el-radio>-->
                     <!--                     </el-radio-group>-->
                     <!--                   </el-form-item>-->
                     <!--                   <el-form-item label="年龄" prop="age">-->
                     <!--                     <el-input-number v-model="personalForm.age" placeholder="请输入年龄" :controls="false"></el-input-number>-->
                     <!--                   </el-form-item>-->

                   </li>

                   <!--                 <li>-->
                   <!--                   <div class="title">其他个人信息</div>-->

                   <!--                   <el-form-item label="个人地址" prop="attr">-->
                   <!--                     <el-input type="text" v-model="personalForm.attr" placeholder="请输入个人地址"></el-input>-->
                   <!--                   </el-form-item>-->
                   <!--                   <el-form-item label="职业" prop="profession">-->
                   <!--                     <el-input type="text" v-model="personalForm.profession" placeholder="请输入职业"></el-input>-->
                   <!--                   </el-form-item>-->

                   <!--                   <el-form-item label="教育背景" prop="age">-->
                   <!--                     <el-input-number v-model="personalForm.age" placeholder="请输入教育背景" :controls="false"></el-input-number>-->
                   <!--                   </el-form-item>-->

                   <!--                 </li>-->

                   <li>
                     <div class="title">账号安全</div>

                     <el-form-item label="" prop="" label-width="0">

                       <el-button type="primary" @click="handleClickChangePassword">修改密码</el-button>
                       <el-button type="primary" @click="handleClickChangeAccount">换绑账号</el-button>
                     </el-form-item>

                   </li>
                 </ul>
               </el-form>

             </template>

           </div>
        </el-card>

      <el-dialog title="修改头像" :visible.sync="editAvatarDialog" width="50%" append-to-body :close-on-click-modal="false">
        <Cropper :Avatarfile="Avatarfile" :editAvatarDialog.sync="editAvatarDialog" @change="getCropper"
                 v-if="editAvatarDialog"/>
      </el-dialog>

      <changePassword :passwordVisible.sync="passwordVisible" v-if="passwordVisible"/>
      <changeAccount :accountVisible.sync="accountVisible" v-if="accountVisible" />


    </div>
</template>

<script>
import { userDetail, userEdit} from '@/api/api'
import {mapState} from "vuex";
import { uploadImg, getOSSData } from '@/utils/uploadOss'
import { VueCropper } from 'vue-cropper'
import changePassword from './change_password.vue'
import changeAccount from './change_account.vue'
import Cropper from '@/components/Cropper'
export default {
    name: 'personal',
    components: {
      Cropper,
      changePassword,
      changeAccount
    },
    data() {
        return {
          loading:false,
          personalForm:{
            name:'',
            avatar:''
          },
          personalDetail:{},
          personalFormRules:{
            avatar:[{ required: true, message: '请上传头像', trigger: 'change'}],
            name:[{ required: true, message: '请输入姓名', trigger: 'blur'}],
          },
          editAvatarDialog: false,
          Avatarfile: '',
          passwordVisible:false,
          BtnDisabled:false,
          isEdit:false,
          accountVisible:false

        }
    },
    created() {
      this.getUserDetail()
    },
    mounted() {
      // if(!this.webUserInfo || !this.webUserInfo.id){
      //   localStorage.removeItem('vuex')
      //   this.$router.replace('/')
      // }
    },
    computed: {
      ...mapState(['webUserInfo']),
    },
    methods: {
      // 获取用户信息
      getUserDetail(){
        this.loading = true
        userDetail().then(res => {
          if (res.code === 200) {
            let {data} = res
            this.personalDetail = data
            this.personalForm.avatar = data.avatar
            this.personalForm.name = data.name
            this.personalForm.email = data.email
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },

      // 编辑
      handleClickEdit(){
        this.isEdit = true
      },
      // 取消
      handleClickCancel(){
        this.isEdit = false
      },
      // 保存
      handleClickConfirm(){
        this.$refs.personalForm.validate(valid => {
          if (valid) {
            let postData = {
              avatar:this.personalForm.avatar,
              name:this.personalForm.name
            }
            this.BtnDisabled = true
            userEdit(postData).then(res => {
              if (res.code === 200) {
                this.$message({
                  message:'修改成功',
                  type: 'success',
                  duration: 1000,
                  onClose: () => {
                    this.BtnDisabled = false
                    location.reload();
                  }
                })
              }else{
                this.BtnDisabled = false
              }
            }).catch((e) => {
              this.BtnDisabled = false
            })
          }
        })
      },



      // 修改密码
      handleClickChangePassword(){
          this.passwordVisible = true
      },

      // 换绑手机
      handleClickChangeAccount(){
         this.accountVisible = true
      },

      // 获取裁剪过的头像
      getCropper (data) {
        this.personalForm.avatar  = data
      },
      //点击上传头像
      handleClickUploadAvatar (file) {

        var _this = this
        var reader = new FileReader()
        reader.readAsDataURL(file.raw)
        reader.onload = function () {
          _this.Avatarfile = this.result
          _this.editAvatarDialog = true

        }
      },

    },
    watch: {

    },
}
</script>

<style scoped lang="scss">
.el-form-item.align-items-center{
  display: flex;
  align-items: center;
}

::v-deep .el-form-item.align-items-center .el-form-item__content{
  margin-left: 0 !important;
}
.page_container .page_card {
    overflow-y: scroll;
    padding-bottom: 0px !important;
    background: transparent !important;
    box-shadow: none;
   ::v-deep .el-card__body{
     padding: 0px !important;
   }
}

.filed_list{
  color: #000;
  line-height: 24px;
  font-size: 16px;
  margin-bottom: 12px;
}


.personal_box{
  width: 100%;
  ul{
    width: 100%;
    li{
      width: 100%;
      margin-bottom: 24px;
      background: #fff;
      border-radius: 8px;
      padding: 24px 20px 6px;
      box-sizing: border-box;
      .title{
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 16px;
      }
      .head_img{
        width: 64px;
        position: relative;
        div.hover_box{
          display: none;
        }
        &:hover div.hover_box{
          z-index: 9;
          width: 64px;
          height: 64px;
          opacity: 0.4;
          background: rgba(0, 0, 0, 1);
          position: absolute;
          border-radius: 50%;
          display: block;
          color: #fff;
          text-align: center;
          line-height: 64px;
          font-size: 14px;
        }
        img{
          display: block;
          width: 64px;
          height: 64px;
          object-fit: cover;
          border-radius: 50%;
          border: 1px solid #ccc;
          box-sizing: border-box;
        }
        ::v-deep .el-upload{
          position: absolute;
          width: 64px;
          height: 64px;
          left: 0;
          top: 0;
          z-index: 10;
        }
      }
      ::v-deep .el-form-item__label{
        line-height: 32px;
      }
      .el-input{
        max-width: 242px;
      }
      .el-input-number{
        max-width: 242px;
        width: 242px;
        ::v-deep .el-input__inner{
          text-align: left;
        }
      }
    }
  }
}







</style>
